import { render } from "./home.vue?vue&type=template&id=2a41186f"
const script = {}

import "./home.vue?vue&type=style&index=0&id=2a41186f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__